
const addHeightWidthToUrl = (urlFrag, height, width) => {
    if (height) urlFrag = `${urlFrag}h_${height}`;
    if (width && !height) urlFrag = `${urlFrag}w_${width}`;
    else if (width) urlFrag = `${urlFrag},w_${width}`;
    urlFrag = `${urlFrag}/`;
    return urlFrag;
};

export const sizeFormattedImageUrl = (url, height, width) => {
    let result = url;
    const imageUploadString = "/image/upload/";
    if (url && url.length && url.includes(imageUploadString)) {
        const urlFrags = url.split(imageUploadString);
        if (urlFrags.length === 2) {
            let stringUpdated = height && width ? `${imageUploadString}c_limit,c_fit,` : `${imageUploadString}c_limit,`;
            stringUpdated = addHeightWidthToUrl(stringUpdated, height, width);
            result = `${urlFrags[0]}${stringUpdated}${urlFrags[1]}`;
        }
    }
    return result;
};

export const sizeFormattedImageUrlWithFaceFocused = (url, height, width) => {
    let result = url;
    const imageUploadString = "/image/upload/";
    if (url && url.length && url.includes(imageUploadString)) {
        const urlFrags = url.split(imageUploadString);
        if (urlFrags.length === 2) {
            let stringUpdated = height && width ? `${imageUploadString}c_limit,c_fill,g_face,` : imageUploadString;
            stringUpdated = addHeightWidthToUrl(stringUpdated, height, width);
            result = `${urlFrags[0]}${stringUpdated}${urlFrags[1]}`;
        }
    }
    return result;
};

export const sanitizeVideoUrl = (url) => {
    return url.includes('/image/upload') ? url.replace("/image/upload", "/video/upload") : url;
};
